import { Redirect, useLocalSearchParams } from "expo-router";
import { ActivityIndicator, View } from "react-native";

import { LeaveRequestDetailScreen } from "@/features/submissions/LeaveRequestDetailScreen";
import { useGetLeaveRequestQuery } from "@/query/apiSlice";

/** Parses a leave-request route id, or null when the param is missing/invalid. */
function parseLeaveRequestId(
    value: string | string[] | undefined,
): number | null {
    const raw = Array.isArray(value) ? value[0] : value;
    if (!raw) {
        return null;
    }

    const parsed = Number(raw);
    if (!Number.isInteger(parsed) || parsed <= 0) {
        return null;
    }

    return parsed;
}

export default function LeaveRequestDetailRoute() {
    const { id } = useLocalSearchParams<{ id: string }>();
    const requestId = parseLeaveRequestId(id);
    const {
        data: request,
        isLoading,
        isError,
    } = useGetLeaveRequestQuery(requestId as number, {
        skip: requestId == null,
    });

    if (requestId == null) {
        return <Redirect href="/" />;
    }

    if (isLoading) {
        return (
            <View className="flex-1 items-center justify-center bg-background">
                <ActivityIndicator />
            </View>
        );
    }

    if (isError || !request) {
        return <Redirect href="/" />;
    }

    return <LeaveRequestDetailScreen request={request} />;
}
